// Copyright (c) 2016 Deere & Company

import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import SearchByDropdown, {getDefaultState as getSearchByDropdownDefaultState} from './search-by-dropdown';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import SearchResults, {getDefaultState as getSearchResultsDefaultState} from './search-results';
import t from 'tcomb';

const PartRequestsSearch = t.struct({
    busyCounter: t.Number,
    facets: Facets,
    filteredSearchResults: SearchResults,
    searchByDropdown: SearchByDropdown,
    searchFilters: SearchFilters,
    searchQueryString: t.String,
    searchResults: SearchResults
}, {
    name: 'PartRequestsSearch',
    strict: true
});

export const getDefaultState = () =>
    new PartRequestsSearch({
        busyCounter: 0,
        facets: getFacetsDefaultState(),
        filteredSearchResults: getSearchResultsDefaultState(),
        searchByDropdown: getSearchByDropdownDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        searchQueryString: '',
        searchResults: getSearchResultsDefaultState()
    });

export default PartRequestsSearch;



// WEBPACK FOOTER //
// ./src/part-requests/search/state/index.js